import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "hide-scrollbar mb-12 snap-x scroll-px-16 overflow-x-scroll whitespace-nowrap" }
const _hoisted_2 = { class: "flex w-fit items-center gap-x-16" }
const _hoisted_3 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.filters, (filter, i) => {
        return (_openBlock(), _createElementBlock("button", {
          key: filter,
          type: "button",
          onClick: $event => ([_ctx.$emit('isSelected', i !== $data.activeFilter ? filter : ''), $options.selectFilter(i)])
        }, [
          _createElementVNode("li", {
            class: _normalizeClass(["snap-start text-14 font-medium text-black-400 hover:text-black-900 hover:underline", {'!text-black-900 underline': $data.activeFilter === i}])
          }, _toDisplayString(filter), 3)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}